/*
*###############################################################################
*Module Name                   : VoucherGroupControl.js                        #
*Purpose of the Module         :                                               #
*Description of the Module     :                                               #
*Original Author               :  W M Shanika Chamodi                          #
*Date                          : Monday, September 27th 2021, 1:19:48 pm       #
*Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
*###############################################################################
*/
//Import react and bootstrap components
import React, { useState } from 'react'
import { CardText, Col, Row, Alert, Button, Label } from 'reactstrap'

//Import Framework components
import DPTextBox from 'framework/components/DPTextBox'
import DPSwitch from 'framework/components/DPSwitch'
import DPTextBoxButton from 'framework/components/DPTextBoxButton'
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"

const VoucherGroupContent = ({
    AlertColor,
    AlertMsg,
    show,
    CodeValue,
    CodeonChange,
    CodeonBlur,
    disabledCode,
    DescValue,
    DescOnChange,
    disabledDesc,
    ActiveonChange,
    ActiveStatus,
    disabledActive,
    Gen_DataSearch,

    SearchModelOpen,
    SearchModelTrigger,
    SearchGetSelectRow,
    SellValue,
    SellOnChange,
    SellOnBlur,
    disabledSelling,
    ValidDaysValue,
    ValidDaysOnChange,
    ValidDaysOnOnBlur,
    disabledValidDays,
    PrintCostValue,
    PrintCostOnChange,
    PrintCostOnOnBlur,
    disabledCost,
    NumberOfVouchersValue,
    NumberOfVouchersOnChange,
    NumberOfVouchersOnBlur,
    disabledVoucherBook,
    BookNumberValue,
    BookNumberOnChange,
    BookNumberOnBlur,
    disabledBookNo,
    EditableChange,
    EditableStatus,
    disabledEditable,
    RandomonChange,
    RandomStatus,
    disabledRandomNo,
    menuName,
    onButtonClick,
    btnDisable,
    SearchDisable,
    menuCode,
    autoCode
}) => {

    const [Datatablesub, SetDatatablesub] = useState([])
    const [groupFilter, SetGroupFilter] = useState('a')
    //*** End of useStates */
    const ApiURL = window.Links.ApiURL

    //default sorted method
    const defaultSorted = [{
        dataField: 'id',
        order: 'asc'
    }];


    const columns2 = [{
        field: "VCG_CODE",
        title: "Code",
        align: "center",
    },
    {
        field: "VCG_DESC",
        title: "Description",
        align: "center",
    },];

    return (
        <React.Fragment>
            <div>
                <Col sm="12">
                    <CardText className="mb-0">
                        <Row>
                            {show ? (
                                <Alert color={AlertColor} role="alert">
                                    {AlertMsg}
                                </Alert>
                            ) : null}
                            <Col sm={12} md={7} className="mb-4-sm">
                                <DPTextBoxButton
                                    rowClass="mb-4-sm"
                                    labelText="Code"
                                    textType="text"
                                    maxLength="3"
                                    value={CodeValue}
                                    onChange={CodeonChange}
                                    disabled={disabledCode}
                                    onBlur={CodeonBlur}
                                    onButtonClick={onButtonClick}
                                    btnDisable={btnDisable}
                                    placeholder={autoCode}
                                />
                                <DPTextBox
                                    rowClass="mb-4-sm"
                                    labelText="Description"
                                    textType="text"
                                    maxLength="60"
                                    value={DescValue}
                                    onChange={DescOnChange}
                                    disabled={disabledDesc}
                                />
                                <DPTextBox
                                    rowClass="mb-4-sm"
                                    labelText="Selling Value per voucher"
                                    textType="text"
                                    maxLength="10"
                                    textAlign="right"
                                    value={SellValue}
                                    onChange={SellOnChange}
                                    disabled={disabledSelling}
                                    onBlur={SellOnBlur}
                                />
                                <DPTextBox
                                    rowClass="mb-4-sm"
                                    labelText="Printing Cost per Book"
                                    textType="text"
                                    maxLength="10"
                                    textAlign="right"
                                    value={PrintCostValue}
                                    onChange={PrintCostOnChange}
                                    disabled={disabledCost}
                                    onBlur={PrintCostOnOnBlur}
                                />
                                <DPTextBox
                                    rowClass="mb-4-sm"
                                    labelText="Valid Days"
                                    textType="text"
                                    maxLength="40"
                                    textAlign="right"
                                    value={ValidDaysValue}
                                    onChange={ValidDaysOnChange}
                                    disabled={disabledValidDays}
                                    onBlur={ValidDaysOnOnBlur}
                                />

                                <DPTextBox
                                    rowClass="mb-4-sm"
                                    labelText="Vouchers in a Book"
                                    textType="text"
                                    maxLength="40"
                                    textAlign="right"
                                    value={NumberOfVouchersValue}
                                    onChange={NumberOfVouchersOnChange}
                                    disabled={disabledVoucherBook}
                                    onBlur={NumberOfVouchersOnBlur}
                                />
                                <DPTextBox
                                    rowClass="mb-4-sm"
                                    labelText="Book Number"
                                    textType="text"
                                    maxLength="40"
                                    textAlign="right"
                                    value={BookNumberValue}
                                    onChange={BookNumberOnChange}
                                    disabled={disabledBookNo}
                                    onBlur={BookNumberOnBlur}
                                />

                            </Col>
                            <Col sm={12} md={1} className="mb-4-sm">
                                <Button
                                    onClick={Gen_DataSearch}
                                    color="success"
                                    className="btn-sm"
                                    disabled={SearchDisable}
                                >
                                    <i
                                        className="mdi mdi-search-web"
                                        style={{ fontSize: "12px" }}
                                    ></i>
                                </Button>
                            </Col>
                            <Col sm={12} md={3} className="mb-4-sm">
                                <Row>
                                    <Col sm={5}>
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Active
                                        </Label>
                                    </Col>
                                    <Col >
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={ActiveonChange}
                                            checked={ActiveStatus}
                                            disabled={disabledActive}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={5}>
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Editable
                                        </Label>
                                    </Col>
                                    <Col >
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={EditableChange}
                                            checked={EditableStatus}
                                            disabled={disabledEditable}
                                        />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm={5}>
                                        <Label
                                            htmlFor="example-text-input"
                                            className={`col-md-12 col-form-label-sm`}
                                        >
                                            Random No.
                                        </Label>
                                    </Col>
                                    <Col >
                                        <DPSwitch
                                            rowClass={"mb-4-sm"}
                                            onChange={RandomonChange}
                                            checked={RandomStatus}
                                            disabled={disabledRandomNo}
                                        />
                                    </Col>
                                </Row>
                            </Col>
                            <DPSearchBoxDynamic
                                searchData={Datatablesub}
                                columns={columns2}
                                defaultSorted={defaultSorted}
                                mainTitle={menuName + " Search"}
                                SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
                                isOpen={SearchModelOpen}
                                toggle={SearchModelTrigger}
                                getSelect={SearchGetSelectRow}
                                APIURL={ApiURL}
                                URLPath={"VOUCHER"}
                                MenuCode={menuCode}
                                KeyVal={'GRP'}
                                searchBy={'VCG_CODE'}
                                FilterStr={groupFilter}
                            />
                        </Row>
                    </CardText>
                </Col>
            </div>
        </React.Fragment>
    );
}

export default VoucherGroupContent